import React from 'react'
import { AuthContext } from './AuthContext'

export const useAuth = () => {
  const state = React.useContext(AuthContext)

  const isAuthenticated = Boolean(state?.user?.accessToken)

  return {
    ...state,
    isAuthenticated
  }
}
